import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import classNames from 'classnames'
import { Stepper, Step, StepLabel, useMediaQuery, MobileStepper, StepContent } from '@material-ui/core'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Typography from '@material-ui/core/Typography';
import Button from '../Button';

import theme from '../../src/ThemeProvider/theme'

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
	},
	alignCenter: {
		display: 'flex',
		justifyContent: 'center',
	},
	mobileHeader: {
		marginBottom: '16px'
	},
}));


export default function StepperWrapper({ defaultStep = 0, getSteps, getStepContent, getSummaryContent, orientation = 'horizontal', ...props }) {

	const {
		displayNextButton,
		displayBackButton,
		stepperOverrides,
		mobileStepperOverrides,
	} = props

	const classes = useStyles();
	const [activeStep, setActiveStep] = React.useState(defaultStep);
	const steps = getSteps();
	const defaultTheme = useTheme(theme)
	const isMobile = useMediaQuery(defaultTheme.breakpoints.down("md"))
	const isVerticalOrientation = orientation === 'vertical'
	const isLastStep = activeStep === steps.length
	const isFirstStep = activeStep === 0

	const stepperConfig = {
		orientation: orientation,
		...stepperOverrides
	}

	const mobileStepperConfig = {
		variant: "dots",
		steps: steps.length,
		position: "static",
		activeStep: activeStep,
		...mobileStepperOverrides
	}

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};

	React.useEffect(() => {
		setActiveStep(defaultStep)
	}, [defaultStep])


	//TODO: Current stepper not cover the skipped, completed steps and etc. Please add incrementally if needed
	//Ref: https://v4.mui.com/components/steppers/

	return (
		<div className={classes.root}>
			{!isMobile && (
				<Stepper activeStep={activeStep} className={classNames(classes.stepper)} {...stepperConfig}>
					{steps.map((label, index) => {
						return (
							<Step key={`${index}-${label}`}>
								<StepLabel>{label}</StepLabel>
								{isVerticalOrientation && <StepContent>
									{!isLastStep && getStepContent({ activeStep, handleNext, handleBack, handleReset })}
								</StepContent>}
							</Step>
						);
					})}
					{isVerticalOrientation && isLastStep && getSummaryContent && getSummaryContent()}
				</Stepper>
			)}
			<div>
				{isMobile &&
					<React.Fragment>
						<MobileStepper
							className={classes.root}
							nextButton={
								displayNextButton ||
								<Button size="small" onClick={handleNext} disabled={isLastStep}>
									<KeyboardArrowRight />
								</Button>
							}
							backButton={
								displayBackButton ||
								<Button size="small" onClick={handleBack} disabled={isFirstStep}>
									<KeyboardArrowLeft />
								</Button>
							}
							{...mobileStepperConfig}
						/>
						<div className={classes.alignCenter}>
							<Typography className={classes.mobileHeader}>{steps[activeStep]}</Typography>
						</div>
					</React.Fragment>
				}
				<div className={classes.alignCenter}>
					{isLastStep && getSummaryContent && getSummaryContent()}
					{!isLastStep && (
						getStepContent({ activeStep, handleNext, handleBack, handleReset })
					)}
				</div>
			</div>
		</div>
	);
}

export const MUIStepContent = ({ ...props }) => <StepContent {...props} />
export const MUIStep = ({ ...props }) => <Step {...props} />
export const MUIStepLabel = ({ ...props }) => <StepLabel {...props} />
export const MUIStepper = ({ ...props }) => <Stepper {...props} />
